import { InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import PasswordRequirement from "../../components/common/PasswordRequirement";

const useRegisterFields = (props?: any) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const passwordRequirementsField = {
    inputType: "customComponent",
    visibility:
      props?.userPage && (props?.isEdit || props?.isApproved)
        ? "noPermission"
        : "true",
    component: <PasswordRequirement />,
  };

  const confirmPasswordField = {
    name: "confirmPassword",
    label: "Confirm Password*",
    size: props?.userPage ? 6 : 12,
    maxlength: 16,
    type: showConfirmPassword ? "text" : "password",
    visibility:
      props?.userPage && (props?.isEdit || props?.isApproved)
        ? "noPermission"
        : "true",
    InputProps: {
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={() => setShowConfirmPassword((show) => !show)}
            onMouseDown={(event) => event.preventDefault()}
            edge="end"
          >
            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    },
  };

  const registerFields = [
    {
      name: "first_name",
      label: "First Name*",
      size: 6,
      maxlength: 100,
      disabled: props?.userPage && props?.isApproved ? true : false,
    },
    {
      name: "last_name",
      label: "Last Name*",
      size: 6,
      maxlength: 100,
      disabled: props?.userPage && props?.isApproved ? true : false,
    },
    {
      name: "email",
      label: "Email Address*",
      size: 12,
      maxlength: 254,
      disabled:
        props?.userPage && (props?.isEdit || props?.isApproved) ? true : false,
    },
    {
      name: "password",
      label: "Password*",
      size: props?.userPage ? 6 : 12,
      maxlength: 16,
      type: showPassword ? "text" : "password",
      visibility:
        props?.userPage && (props?.isEdit || props?.isApproved)
          ? "noPermission"
          : "true",
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword((show) => !show)}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      },
    },
    props?.userPage ? confirmPasswordField : passwordRequirementsField,
    !props?.userPage ? confirmPasswordField : passwordRequirementsField,
  ];

  return { registerFields };
};

export default useRegisterFields;
